






import {Component, Vue} from "vue-property-decorator"
import {appConfig} from "@/config/app.config"

@Component
export default class Footer extends Vue {
    private get version() {
        return `${appConfig.VERSION}${appConfig.IS_TARGETING_PRODUCTION ? "" : " --> DEV"}`
    }
}
